'use strict';

define(['utils/underscore', 'utils/helpers'], function (_, utils) {

    var storage = {
        getItem: utils.noop,
        setItem: utils.noop,
        removeItem: utils.noop
    };

    try {
        storage = window.localStorage;
    } catch (e) {/* ignore */}

    function jwPrefix(str) {
        var prefix = 'baiducyberplayer.' + str;
        return prefix.toString();
    }

    function getAllItems() {
        return _.reduce(this.persistItems, function (memo, key) {
            var val = storage[jwPrefix(key)];
            if (val) {
                memo[key] = utils.serialize(val);
            }
            return memo;
        }, {});
    }

    function setItem(name, value) {
        try {
            storage[jwPrefix(name)] = value;
        } catch (e) {
            // ignore QuotaExceededError unless debugging
            if (__DEBUG__) {
                console.error(e);
            }
        }
    }

    function getItem(name) {
        return storage[jwPrefix(name)];
    }

    function clearItem(name) {
        return storage.removeItem(jwPrefix(name));
    }

    function clear() {
        _.each(this.persistItems, function (val) {
            storage.removeItem(jwPrefix(val));
        });
    }

    function Storage() {
        this.persistItems = ['volume', 'mute', 'captionLabel', 'qualityLabel', 'playbackRate'];
    }

    function track(model) {
        _.each(this.persistItems, function (item) {
            model.on('change:' + item, function (model, value) {
                setItem(item, value);
            });
        });
    }

    _.extend(Storage.prototype, {
        getAllItems: getAllItems,
        track: track,
        clear: clear,
        setItem: setItem,
        getItem: getItem,
        clearItem: clearItem
    });

    return Storage;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controller/storage.js
 ** module id = 145
 ** module chunks = 0
 **/